"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var ExceptionHandler_1 = require("../../../models/common/base/ExceptionHandler");
var Permissions = /** @class */ (function () {
    function Permissions() {
        this.rbacPermissions = {
            isTypeDefCreate: false,
            isTypeDefRead: false,
            isTypeDefWrite: false,
            isTypeDefDelete: false,
            isObjectCreate: false,
            isObjectRead: false,
            isObjectWrite: false,
            isObjectDelete: false,
            isFileUpload: false,
            isFileDownload: false,
            isFileSearch: false,
            isFileDelete: false
        };
        this._exceptionHandler = new ExceptionHandler_1.ExceptionHandler();
    }
    Permissions.prototype.loadAvailablePermissions = function (permissions) {
        this._availablePermissions = permissions;
    };
    Permissions.prototype.loadPermissions = function (userPermissions) {
        this.mapPermissions(userPermissions);
    };
    ;
    Permissions.prototype.verifyTypeDefCreatePermission = function () {
        if (!this.rbacPermissions.isTypeDefCreate) {
            this.forbidAccess();
        }
    };
    Permissions.prototype.verifyTypeDefReadPermission = function () {
        if (!this.rbacPermissions.isTypeDefRead) {
            this.forbidAccess();
        }
    };
    Permissions.prototype.verifyTypeDefWritePermission = function () {
        if (!this.rbacPermissions.isTypeDefWrite) {
            this.forbidAccess();
        }
    };
    Permissions.prototype.verifyTypeDefDeletePermission = function () {
        if (!this.rbacPermissions.isTypeDefDelete) {
            this.forbidAccess();
        }
    };
    Permissions.prototype.verifyObjectCreatePermission = function () {
        if (!this.rbacPermissions.isObjectCreate) {
            this.forbidAccess();
        }
    };
    Permissions.prototype.verifyObjectReadPermission = function () {
        if (!this.rbacPermissions.isObjectRead) {
            this.forbidAccess();
        }
    };
    Permissions.prototype.verifyObjectWritePermission = function () {
        if (!this.rbacPermissions.isObjectWrite) {
            this.forbidAccess();
        }
    };
    Permissions.prototype.verifyObjectDeletePermission = function () {
        if (!this.rbacPermissions.isObjectDelete) {
            this.forbidAccess();
        }
    };
    Permissions.prototype.verifyFileUploadPermission = function () {
        if (!this.rbacPermissions.isFileUpload) {
            this.forbidAccess();
        }
    };
    Permissions.prototype.verifyFileDownloadPermission = function () {
        if (!this.rbacPermissions.isFileDownload) {
            this.forbidAccess();
        }
    };
    Permissions.prototype.verifyFileSearchPermission = function () {
        if (!this.rbacPermissions.isFileSearch) {
            this.forbidAccess();
        }
    };
    Permissions.prototype.verifyFileDeletePermission = function () {
        if (!this.rbacPermissions.isFileDelete) {
            this.forbidAccess();
        }
    };
    /**Throws access forbidden error */
    Permissions.prototype.forbidAccess = function () {
        /* Commenting this part of code as its handling from the API side */
        // const error = this._exceptionHandler.buildExceptionFromErrorMessage("Access Forbidden", 403, "Access Forbidden", "Access Forbidden");
        // throw new Error(error);
    };
    Permissions.prototype.mapPermissions = function (permissions) {
        var _this = this;
        lodash_1.map(permissions, function (permission) {
            var permissionVariableName = lodash_1.find(Object.keys(_this._availablePermissions), function (permissionVariable) {
                return _this._availablePermissions[permissionVariable] === permission;
            });
            if (permissionVariableName && (permissionVariableName in _this.rbacPermissions)) {
                _this.rbacPermissions[permissionVariableName] = true;
            }
        });
    };
    return Permissions;
}());
var rbacPermissions = new Permissions();
exports.rbacPermissions = rbacPermissions;
//# sourceMappingURL=Permissions.js.map